import {
  Cancel,
  Info,
  InfoOutlined,
  PriorityHigh,
  Report,
  Warning,
} from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

export type IconNames =
  | "cancel"
  | "info"
  | "warning"
  | "report"
  | "infoOutlined"
  | "priorityHigh";

interface IconsInfo {
  title: React.ReactNode;
  iconName: IconNames;
  dataTestId?: string;
}

const WarningIconBadge = ({ iconName, title, dataTestId }: IconsInfo) => {
  const theme = useTheme();
  const iconMap = new Map<
    IconNames,
    { icon: React.ReactElement; color: string }
  >([
    [
      "cancel",
      {
        icon: (
          <Cancel
            data-testid="CancelIcon"
            sx={{
              color: theme.tokens.FuelColorAlertErrorIcon,
              fontSize: "1rem",
            }}
          />
        ),
        color: "#ffc7c2",
      },
    ],
    [
      "info",
      {
        icon: (
          <Info
            data-testid="InfoIcon"
            sx={{
              color: theme.tokens.FuelColorAlertInfoIcon,
              fontSize: "1rem",
            }}
          />
        ),
        color: "#c4daed",
      },
    ],
    [
      "warning",
      {
        icon: (
          <Warning
            data-testid="WarningIcon"
            sx={{
              color: theme.tokens.FuelColorAlertWarningIcon,
              fontSize: "1rem",
            }}
          />
        ),
        color: "#fee7c4",
      },
    ],
    [
      "report",
      {
        icon: (
          <Report
            data-testid="ReportIcon"
            sx={{
              color: theme.tokens.FuelColorAlertErrorIcon,
              fontSize: "1rem",
            }}
          />
        ),
        color: "#ffc7c2",
      },
    ],
    [
      "infoOutlined",
      {
        icon: (
          <InfoOutlined
            data-testid="InfoOutlinedIcon"
            sx={{
              color: theme.tokens.FuelColorAlertInfoIcon,
              fontSize: "1rem",
            }}
          />
        ),
        color: "#c4daed",
      },
    ],
    [
      "priorityHigh",
      {
        icon: (
          <PriorityHigh
            data-testid="PriorityHighIcon"
            sx={{
              color: theme.tokens.FuelColorAlertWarningIcon,
              fontSize: "1rem",
            }}
          />
        ),
        color: "#fee7c4",
      },
    ],
  ]);

  return (
    <Tooltip
      data-testid={dataTestId}
      title={title}
      placement="top-end"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -4],
              },
            },
          ],
        },
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: "0.5rem",
          fontWeight: "600",
          justifyContent: "center",
          lineHeight: "1rem",
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          boxSizing: "border-box",
          border: "1px solid transparent",
          padding: "4px",
          backgroundColor: iconMap.get(iconName)?.color,
          columnGap: "0rem",
        }}
      >
        {iconMap.get(iconName)?.icon}
      </Box>
    </Tooltip>
  );
};

export default WarningIconBadge;
